import React, { useState } from 'react';
import icon from '../../../assets/shareholdersIcon.png';
import { Button, Checkbox, Label, Textarea } from 'flowbite-react';
import FileUploadCard from '../../../components/FileUploadCard/FileUploadCard';
import CustomInput from '../../../components/CustomInputs/CustomInput';
import { FaPlusCircle } from 'react-icons/fa';
import CustomModal from '../../../components/Modal/CustomModal';
import AddDeliveryFee from './AddDeliveryFee';
import { serialize } from 'object-to-formdata';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';

interface AddProductModalProps{
    onClose:()=>void,
    onSuccess:()=>void
}
const AddProductModal = ({onClose, onSuccess}:AddProductModalProps) => {
    const [step, setStep] = useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [inputs, setInputs] = useState<any>({
        name: "",
        description: "",
        price: "",
        url: "",
        stock:0,
        fee:0,
        images: null,
        containsPhysicalGoods: false,
        deliveryAddressRequired: false,
        deliveryNoteRequired: false,
        onDeal:false
    });

    const handleInputChange = (name: string, value: any) => {
        setInputs((prev: any) => ({ ...prev, [name]: value }));
    };

    const addNewProduct = async() => {
        let payload = {
            Name: inputs.name,
            Description: inputs.description,
            Price: inputs.price,
            Url: inputs.url,
            Stock:inputs.stock,
            Images: inputs.images,
            ContainsPhysicalGoods: inputs.containsPhysicalGoods,
            DeliveryAddressRequired: inputs.deliveryAddressRequired,
            Fee: inputs.fee,
            DeliveryNoteRequired: inputs.deliveryNoteRequired,
            OnDeal:inputs.onDeal
        }

        let data = serialize(payload)

        try {
            const response = await client.post('/subsidiary/dashboard/product/create', data,  {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(response);
            const message = response?.data?.message;
            showToast(message,"success")
            onSuccess()
            onClose()
    
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }

    }
    return (
        <div>
            <div>
                <img src={icon} className='my-3' alt="Product Icon" />
                <div className='my-3'>
                    <p className='text-xl font-bold'>Add New Product</p>
                    <p className='text-sm'>Kindly fill in the information needed</p>
                </div>
            </div>
            <div>
                {step == 1 && (
                    <>
                        <CustomInput label='Product name' name='productName' value={inputs.name} onChange={(e) => handleInputChange('name', e.target.value)}/>
                        <div>
                            <div className="mb-2 block">
                                <Label htmlFor="description" value="Product Description"  />
                            </div>
                            <Textarea id="description" placeholder="Leave a description" required rows={4} value={inputs.description} onChange={(e) => handleInputChange('description', e.target.value)} />
                        </div>
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mt-4'>
                            <CustomInput label='Price' name='price' value={inputs.price} onChange={(e) => handleInputChange('price', e.target.value)}/>
                            <CustomInput label='Stock' name='stock' value={inputs.stock} onChange={(e) => handleInputChange('stock', e.target.value)}/>
                        </div>
                        <div>
                            <div className='flex items-center gap-3'>
                                <Checkbox />
                                <p>Limited</p>
                            </div>
                            <div className='flex items-center gap-3'>
                                <Checkbox />
                                <p>UnLimited</p>
                            </div>
                        </div>

                        <div className='flex gap-4 my-4'>
                            <Button className='w-1/4 hover:bg-white text-black' outline onClick={()=>onClose()}>Cancel</Button>
                            <Button className='w-3/4 bg-custom-button-green' onClick={() => setStep(2)}>Next</Button>
                        </div>

                    </>
                )}
                {step === 2 && (
                    <div>
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-center'>
                            <div>
                                <p>Sale</p>
                                <p className='flex items-center gap-4'>
                                    <Checkbox
                                        checked={inputs.onDeal}
                                        onChange={(e) => handleInputChange('onDeal', e.target.checked)}
                                    />
                                    This product is on sale
                                </p>
                                <div className='my-4'>
                                    <CustomInput
                                        placeholder='Enter sale amount'
                                        label='Sale Amount'
                                        name='amount'
                                        value={inputs.price}
                                        onChange={(e) => handleInputChange('price', e.target.value)}
                                    />
                                    <CustomInput
                                        label='Product URL'
                                        name='productUrl'
                                        value={inputs.url}
                                        onChange={(e) => handleInputChange('url', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <FileUploadCard
                                    label=""
                                    subtitleText='Click to upload up to 6 quality images'
                                    onChange={(files) => handleInputChange('images', files)}
                                />
                            </div>
                        </div>
                        <div>
                            <p>Delivery</p>
                            <div>
                                <p className='flex items-center gap-4 py-2'>
                                    <Checkbox
                                        checked={inputs.containsPhysicalGoods}
                                        onChange={(e) => handleInputChange('containsPhysicalGoods', e.target.checked)}
                                    />
                                    This product contains one or more physical goods
                                </p>
                                <p className='flex items-center gap-4 py-2'>
                                    <Checkbox
                                        checked={inputs.deliveryAddressRequired}
                                        onChange={(e) => handleInputChange('deliveryAddressRequired', e.target.checked)}
                                    />
                                    Require delivery address
                                </p>
                                <p className='flex items-center gap-4 py-2'>
                                    <Checkbox
                                        checked={inputs.deliveryNoteRequired}
                                        onChange={(e) => handleInputChange('deliveryNoteRequired', e.target.checked)}
                                    />
                                    Require delivery note
                                </p>
                                <div className='flex items-center gap-2 text-green-700 my-4' onClick={() => setOpenModal(true)}>
                                    <FaPlusCircle />
                                    Add delivery fee
                                </div>
                                <div className='flex gap-4'>
                                    <Button className='w-1/4 hover:bg-white text-black' outline onClick={()=>setStep(1)}>Back</Button>
                                    <Button className='w-3/4 bg-custom-button-green' onClick={() => addNewProduct()}>Add New Product</Button>
                                </div>
                                <CustomModal
                                    dismissible
                                    show={openModal}
                                    size='md'
                                    icon=''
                                    onClose={() => setOpenModal(false)}
                                    title='Add Delivery Fee'
                                >
                                    <AddDeliveryFee fee={inputs.fee} setInputs={setInputs} inputs={inputs} handleClose={() => setOpenModal(false)} />
                                </CustomModal>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddProductModal;
